import React from "react";
import Navbar from "./Navbar";
import classes from "./Header.module.css";
import Button from "react-bootstrap/Button";

function Header(props) {
  return (
    <div className={classes.Headercontainer1}>
      <header className={classes["main-header"]}>
        <div className={classes.headerimage}>
          <h1 style={{ color: "white", fontSize: "24px", margin: 0 }}>
            Pinnacle Inventory
          </h1>
        </div>
      </header>
    </div>
  );
}

export default Header;
